// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"386":"e366dd81","540":"16e13480","718":"48fc6005","807":"d47e9610","817":"a2c3a8e4","934":"d60f531c"}[chunkId] + ".chunk.js";
};